
















































import {Component, Vue} from "vue-property-decorator";
import PayrollService from "@/services/payroll/PayrollService";
import {namespace} from "vuex-class";
import Form1042DTO from "@/dto/payroll/Form1042DTO";
import Upload1042Modal from "@/components/payroll/business/Upload1042Modal.vue";
import {processError} from "@/utils/ComponentUtils";
import DeleteConfirmationModal from "@/components/util/DeleteConfirmationModal.vue";

const AppModule = namespace("App");

@Component
export default class BusinessForms1042 extends Vue {

  @AppModule.Action
  private startLoading!: () => void;

  @AppModule.Action
  private stopLoading!: () => void;

  private message = "";

  private successful = true;

  private forms: Array<Form1042DTO> = [];

  mounted(): void {
    this.loadForms();
  }

  loadForms(): void {
    this.startLoading();
    PayrollService.getForms1042(this.companyId).then(
        response => {
          this.forms = response.data;
          this.successful = true;
          this.stopLoading();
        },
        error => processError(error, this)
    );
  }

  get companyId(): number {
    return Number.parseInt(this.$route.params.companyId);
  }

  addNewForm() {
    this.$modal.show(
        Upload1042Modal,
        {
          onFilesUploaded: () => this.loadForms(),
          companyId: this.companyId
        });
  }

  confirmDelete(form: Form1042DTO) {
    this.$modal.show(
        DeleteConfirmationModal,
        {
          onDelete: () => this.deleteForm(form.id)
        },
        {width: "50%", height: "auto"}
    );
  }

  deleteForm(id: number) {
    this.startLoading();
    PayrollService.deleteDocument(id, 'FORM_1042').then(
        ok => {
          this.stopLoading();
          this.loadForms();
        },
        err => processError(err, this)
    )
  }
}
